import { Button } from 'antd';
import { useCallback, useState } from 'react';
import List from 'src/components/grid.component/index'
import { AddresssHandler, CreditHandler, DateHandler, StatusHandler, TransactionHash } from './service';
import EnergyTransactions from './energyTransactions';

const RecentEnergyTransactions = ({ setIsEnergyGridRefresh, isEnergyGridRefresh }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);


  const handleClose = useCallback(() => {
    setIsModalVisible(false);
  }, [])
  const handleHash = useCallback((data) => () => {
    window.open(data.url)
  }, [])
  const energyTransactionHandler = useCallback((data) => {
    return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
  }, [])
  const addressHandler = useCallback((data) => {
    return <AddresssHandler data={data?.dataItem} />
  }, [])
  const creditHandler = useCallback((data) => {
    return <CreditHandler data={data?.dataItem} />
  }, [])
  const dateHandler = useCallback((data) => {
    return <DateHandler data={data?.dataItem} />
  }, [])
  const statusHandler = useCallback((data) => {
    return <StatusHandler data={data?.dataItem} />
  }, [])
  const customcells = {
    "transactionhash": energyTransactionHandler,
    "address": addressHandler,
    "credits": creditHandler,
    "date": dateHandler,
    "status": statusHandler,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells])
  const refreshCallBack = useCallback(() => {
    setIsEnergyGridRefresh(false)
  }, [])
  return (
    <div className='mt-5'>
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-2xl font-semibold text-titleColor">
          Recent Energy Used Transactions
        </h2>
        <Button type="default" className="cancel-btn !px-4 !py-1 !h-auto" onClick={showModal}>
          See All
          <span className="icon icon-arrow-right ml-2"></span>
        </Button>
        {isModalVisible && <EnergyTransactions visible={isModalVisible} onClose={handleClose} />}
      </div>

      <List
        url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/transactions/null/null/null`}
        pSize={5}
        className="custom-grid"
        pageable={false}
        screenName={'Energy_Recharge_Transactions'}
        renderCustomCell={renderCustomCell}
        refreshCallBack={refreshCallBack}
        refresh={isEnergyGridRefresh}
      />
    </div>
  );
};
export default RecentEnergyTransactions;